import * as d3 from 'd3';
import * as d3Beeswarm from 'd3-beeswarm';

const NL = {
	"decimal": ",",
	"thousands": ".",
	"grouping": [3],
	"currency": ["€", ""],
	"dateTime": "%a %e %B %Y %X",
	"date": "%d-%m-%Y",
	"time": "%H:%M:%S",
	"periods": ["AM", "PM"],
	"days": ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"],
	"shortDays": ["zo", "ma", "di", "wo", "do", "vr", "za"],
	"months": ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"],
	"shortMonths": ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"]
}

const localeNL = d3.timeFormatDefaultLocale(NL);
const axisFormatter = d3.timeFormat("%B '%y");

class Biolabs {

	container(loc) {
		this.loc = loc;
		this.width = d3.select(loc).node().clientWidth;
		this.height = d3.select(loc).node().clientHeight;

		return this;	
	}

	callBacks(callBacks) {
		this.updateTooltip = callBacks["updateTooltip"];

		return this;
	}

	prepareSwarm(data){
		this.data = data;

		// datumformaat in data: "2021-03-21 15:00:00"
		this.data.forEach((d) => {
			d.date = new Date(d.date.replace(" ", "T"));
		});

		//extent
		const min = new Date("2022-02-20T15:00:00");
		const max = d3.max(this.data, function(d) {
			return d.date; 
		});

		//sorteren
		this.data = this.data.sort((a, b) => {
			return b.views - a.views;
		});

		const xScale = d3.scaleTime()
			.domain([min, max])
			.range([0, this.width - 20]);

		this.xScale = xScale;

		this.swarm = d3Beeswarm.beeswarm()
			.data(this.data)
			.distributeOn(function(d) {
				return xScale(d.date);
			})
			.radius(5)
			.orientation("horizontal")
			.side("symmetric")
			.arrange();

		return this;
	}

	render() {
		
		this.svg = d3.select(this.loc)
			.append("svg")
				.attr("width", this.width)
				.attr("height", this.height);

		this.circles = this.svg.selectAll('circle')
			.data(this.swarm)
			.enter()
				.append('circle')
					.attr('cx', (d) => {
						return d.x;
					})
					.attr('cy', (d) => {
						return d.y + (this.height / 2);
					})
					.attr('r', 5)
					.style("fill", "#FF5362")
					.style("opacity", (d) => {
						return this.opa(d.datum.views);
					})
					.on("click", (evt, d) => {
						this.updateTooltip({
							"naam": d.datum["authorUsername"],
							"datum": axisFormatter(d.datum["date"]),
							"tekst": d.datum["messageText"]
						});
					});

		var x_axis = d3.axisBottom(this.xScale)
			.ticks(this.width / 100)
			.tickFormat(axisFormatter);

		this.svg.append("g")
				.attr("transform", "translate(0, " + (this.height - 100) + ")")
				.call(x_axis)

		return this;
	}

	opa(views) {
		return views / 10000;
	}
	
}

export default Biolabs;